module.exports = __webpack_public_path__ + "assets/611b419d93210e9f788dc90d0421e92c.svg";